"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalDsEventType = exports.isHistoricalConfig = void 0;
const isHistoricalConfig = (cfg) => {
    return (cfg !== null && 'tab_schema_mapping' in cfg && 'unified_tabs' in cfg && 'tab_grouping' in cfg);
};
exports.isHistoricalConfig = isHistoricalConfig;
var HistoricalDsEventType;
(function (HistoricalDsEventType) {
    HistoricalDsEventType["RECREATE_HISTORICAL_DS"] = "recreate_historical_ds";
    HistoricalDsEventType["RECREATE_HISTORICAL_DS_EVOLVED_PLAN"] = "recreate_historical_ds_evolved_plan";
})(HistoricalDsEventType = exports.HistoricalDsEventType || (exports.HistoricalDsEventType = {}));
